import * as React from 'react';
import ReviewerDisplayContainer from '../ReviewerDisplay/ReviewerDisplayContainer';
import AddReviewersButtonContainer from '../AddReviewersButton/AddReviewersButtonContainer';
import Constants from '../../globals/Constants';
import ReviewModel from '../../types/ReviewModel';
import UserModel from '../../types/UserModel';

export default ({review, currentUser}: ToolbarProps) => {
   const isOwner = currentUser.userId && review && review.Reviewers && review.Reviewers.filter(reviewer => reviewer.Id === currentUser.userId && reviewer.Role === Constants.reviewerRoles.owner).length > 0;

   return (
      <div className="review-toolbar">
         {isOwner && <AddReviewersButtonContainer />}
         <ReviewerDisplayContainer review={review}/>
      </div>
   );
};

export interface ToolbarProps {
   review: ReviewModel;
   currentUser: UserModel;
}
